module.exports = __webpack_public_path__ + "img/Italian House.a7f3b481.jpg";